import Vue from 'vue';

let action = function (el, binding, vnode) {
  const { value } = binding;
  const premissionList = JSON.parse(localStorage.getItem('userAuths')) || [];
  const oldUserSeeAmount = localStorage.getItem('oldUserSeeAmount');
  premissionList.push(oldUserSeeAmount);
  if (value) {
    const permissionRoles = value;
    const hasPermission = premissionList.includes(permissionRoles);

    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  } else {
    throw new Error(`need roles! Like v-limit="admin"`);
  }
};
const premission = Vue.directive('limit', {
  inserted(el, binding, vnode) {
    action(el, binding, vnode);
  },
  update(el, binding, vnode) {
    action(el, binding, vnode);
  },
});


export default premission;



// WEBPACK FOOTER //
// ./src/directive/limit.js